export default __webpack_public_path__ + "static/media/phone-3.bbdce9e9.svg";